import React, { useEffect, useState, useContext } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import Context from "../Context";

/**
 * component for existing and active item types in service.
 * first in construction fetches existing item types and renders them
 * in a <select> and <option> tags
 *
 * @author mr-exception
 * @version 1.0.0
 *
 * @argument name:string the name of field. when user selects an option, component returns the selected value whit this name
 * @argument index:integer a unique key number to order the component in list
 * @argument value:string default value for component
 * @argument changed:function with an object parameter, that is called when user selects an option and send and object in format {[name] : [value]}
 */

const ItemTypeSelect= ({ value, changed }) => {
  const context = useContext(Context);

  const [itemSchemasLoading, setItemSchemasLoading] = useState(true);
  const [itemSchemas, setItemSchemas] = useState([]);

  const loadItemSchemas = () => {
    setItemSchemasLoading(true);
    context.ApiDriver.getItemSchemas(
      {},
      (response) => {
        setItemSchemas(response);
        setItemSchemasLoading(false);
      },
      (error) => {
        setItemSchemasLoading(false);
      }
    );
  };

  // if (itemSchemas.length === 0)
  //   getItemSchemas(
  //     uni_cookies,
  //     (itemSchemas) => {
  //       const itemSchemas = itemSchemas.map((item) => {
  //         return {
  //           label: (item.title_fa || "") === "" ? item.title_en : item.title_fa,
  //           value: item.id,
  //           direction: (item.title_fa || "") === "" ? "ltr" : "rtl",
  //           slug: item.csl_slug,
  //           status: item.status,
  //           icon: item.icon,
  //         };
  //       });
  //       this.setState({
  //         itemSchemas,
  //         itemSchemasLoading: false,
  //       });
  //     },
  //     () => {}
  //   );

  useEffect(loadItemSchemas, []);

  return (
    <Select
      id="react-select"
      styles={{
        option: (provided, state) => {
          let background = "#FFF";
          let color = "#000";
          if (state.isSelected) {
            background = "#48a4b3";
            color = "#FFF";
          } else if (state.isFocused) {
            background = "white";
            color = "#000";
          } else if (state.isDisabled) {
            background = "#EEE";
            color = "#000";
          }
          return {
            ...provided,
            background,
            color,
          };
        },
      }}
      isLoading={itemSchemasLoading}
      loadingMessage={() => "صبر کنید ..."}
      placeholder="انتخاب نوع منبع ..."
      onChange={({ value }) => {
        changed(value);
      }}
      isRtl={true}
      value={value ? { label: value.title_fa } : null}
      isSearchable={false}
      options={itemSchemas.map((item) => {
        if (item.status === 2) {
          return {
            value: item,
            isDisabled: item.status === 2,
            label: (
              <OverlayTrigger
                key={item.value}
                placement="top"
                overlay={
                  <Tooltip
                    style={{ direction: "rtl" }}
                    id={`tooltip-${item.value}`}
                  >
                    جهت استفاده پژوهیار را نصب کنید.
                  </Tooltip>
                }
              >
                <div className="cite__disabledItem">
                  <img
                    width="15"
                    alt="icon"
                    style={{ marginLeft: 10 }}
                    src={item.icon}
                  />
                  {item.title_fa}
                </div>
              </OverlayTrigger>
            ),
          };
        } else {
          return {
            value: item,
            isDisabled: item.status === 2,
            label: (
              <div className="cite__useableItem">
                <img
                  width="15"
                  alt="icon"
                  style={{ marginLeft: 10 }}
                  src={item.icon}
                />
                {item.title_fa}
              </div>
            ),
          };
        }
      })}
    />
  );
};


export default ItemTypeSelect
